import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/services/virtual-makeup-snapchat"
    path="business/services/virtual-makeup-snapchat"
    element={<AsyncPage />}
  />,
];
